import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NbThemeService } from '@nebular/theme';
import { CalendarView } from 'angular-calendar';
import { NgxSpinnerService } from 'ngx-spinner';
import { takeUntil } from 'rxjs';
import { getDateAndMonth } from '../../../../config/video-tutorial-data';
import { ClearObservableHelper } from '../../../../helpers/ClearObservableHelper';
import { User } from '../../../../interface/user';
import { ChartService } from '../../../../services/chart.service';
import { StorageService } from '../../../../services/storage.service';

@Component({
  selector: 'ngx-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss'],
})
export class ChartComponent extends ClearObservableHelper implements OnInit {
  @Input() currentUser: User;
  @Input() isExpand: boolean;
  loading = false;
  viewDate: Date = new Date();
  isMock = this.storageService.getItem('user').user['is_trial_user'] ? true : false;
  calendarViewType = CalendarView.Month;
  period: string = 'week';
  type: string = 'week';
  types: string[] = ['week', 'month'];
  mergeOptions: any;
  isCalendarStart = false;
  isCalendarEnd = false;
  dividedMonthsValues = [];
  count = 0;
  currentTheme: string;
  options;
  currentSchoolCalendar: any;
  constructor(
    private chartService: ChartService,
    public storageService: StorageService,
    public router: Router,
    private themeService: NbThemeService,
    private spinner: NgxSpinnerService,
    private cdr: ChangeDetectorRef,
  ) {
    super();
  }

  async ngOnInit() {
    try {
      this.currentSchoolCalendar = this.storageService.getItem('selectedSchoolCalendarByAdmin');
      // Listen for changes to the selected school  and update chart data accordingly
      this.storageService.setSelectedSchoolsToLocalStorage.pipe(takeUntil(this.destroy$)).subscribe(async (res) => {
        if (res) {
          this.currentSchoolCalendar = this.storageService.getItem('selectedSchoolCalendarByAdmin');
          this.setViewDate();
          this.disableCalendarAsPerDate();
          await this.refreshChartData();
          this.cdr.detectChanges();
        }
      });

      /**
       * Listen for school calendar changes and refresh chart data accordingly
       */
      this.storageService.setSelectedSchoolsCalendarToLocalStorage
        .pipe(takeUntil(this.destroy$))
        .subscribe(async (res) => {
          if (res) {
            this.currentSchoolCalendar = res;
            this.setViewDate();
            this.disableCalendarAsPerDate();
            await this.refreshChartData();
            this.cdr.detectChanges();
          }
        });

      this.loading = true;
      this.chartService.initializeData();
      this.themeService.onThemeChange().subscribe((res) => {
        this.loading = true;
        this.currentTheme = res?.name;
        this.setOptions();
        if (this.currentUser) {
          this.setViewDate();
          this.disableCalendarAsPerDate();
        }

        this.getWeeksOfMonth();
        this.loading = false;
      });
      this.setOptions();

      if (this.currentUser) {
        this.setViewDate();
        this.disableCalendarAsPerDate();
      }

      await this.getWeeksOfMonth();
      this.loading = false;
      this.spinner.hide();
    } catch (error) {
      // console.log(error)
      this.spinner.hide();
      this.loading = false;
    }
  }

  // setOptions() {
  //   this.loading = true;
  //   try {
  //     this.options = {
  //       legend: {
  //         textStyle: {
  //           color:
  //             this.currentTheme === 'material-dark' ? '#d1d5d8' : '#424242',
  //         },
  //       },
  //       tooltip: {
  //         trigger: 'axis',
  //         axisPointer: {
  //           type: 'shadow',
  //           shadowStyle: {
  //             color: 'rgba(0, 0, 0, 0.3)',
  //           },
  //         },
  //       },
  //       grid: {
  //         left: '3%',
  //         right: '4%',
  //         bottom: '3%',
  //         containLabel: true,
  //       },
  //       dataset: {
  //         source: [],
  //       },
  //       xAxis: {
  //         type: 'category',

  //         axisTick: {
  //           alignWithLabel: true,
  //         },
  //         axisLabel: {
  //           fontSize: 18,
  //           color: '#828282',
  //         },
  //         axisLine: {
  //           lineStyle: {
  //             color: '#A3A3A3',
  //           },
  //         },
  //       },
  //       yAxis: {
  //         type: 'value',
  //         max: 100,

  //         interval: 20,
  //         axisLabel: {
  //           fontSize: 18,
  //           color: '#828282',
  //         },
  //         axisLine: {
  //           show: true,
  //           lineStyle: {
  //             color: '#A3A3A3',
  //           },
  //         },
  //         splitLine: {
  //           // show: true,
  //           lineStyle: {
  //             color: '#f5f5f5',
  //           },
  //         },
  //       },
  //       series: [
  //         {
  //           type: 'bar',
  //           barGap: 0,
  //           barWidth: '20%',
  //           itemStyle: {
  //             normal: {
  //               color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
  //                 {
  //                   offset: 0,
  //                   color: 'rgb(235, 235, 235)',
  //                 },
  //                 {
  //                   offset: 1,
  //                   color: 'rgb(235, 235, 235)',
  //                 },
  //               ]),
  //             },
  //           },
  //         },
  //         {
  //           type: 'bar',
  //           barGap: 0,
  //           barWidth: '20%',
  //           itemStyle: {
  //             normal: {
  //               color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
  //                 {
  //                   offset: 0,
  //                   color:
  //                     this.currentTheme === 'material-dark'
  //                       ? 'rgb(185,153,255)'
  //                       : 'rgb(98, 0, 238)',
  //                 },
  //                 {
  //                   offset: 1,
  //                   color:
  //                     this.currentTheme === 'material-dark'
  //                       ? 'rgb(185,153,255)'
  //                       : 'rgb(98, 0, 238)',
  //                 },
  //               ]),
  //             },
  //           },
  //         },
  //         {
  //           type: 'bar',
  //           barGap: 0,
  //           barWidth: '20%',
  //           itemStyle: {
  //             normal: {
  //               color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
  //                 {
  //                   offset: 0,
  //                   color: 'rgb(96, 175, 32)',
  //                 },
  //                 {
  //                   offset: 1,
  //                   color: 'rgb(96, 175, 32)',
  //                 },
  //               ]),
  //             },
  //           },
  //         },
  //         {
  //           type: 'bar',
  //           barGap: 0,
  //           barWidth: '20%',
  //           itemStyle: {
  //             normal: {
  //               color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
  //                 {
  //                   offset: 0,
  //                   color: '#F6BE00',
  //                 },
  //                 {
  //                   offset: 1,
  //                   color: '#F6BE00',
  //                 },
  //               ]),
  //             },
  //           },
  //         },
  //       ],
  //     };
  //     this.loading = false;
  //   } catch {
  //     // console.log('error);
  //   }
  // }

  setOptions() {
    this.loading = true;
    try {
      this.options = {
        legend: {
          textStyle: {
            color: this.currentTheme === 'material-dark' ? '#d1d5d8' : '#424242',
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            shadowStyle: {
              color: 'rgba(0, 0, 0, 0.3)',
            },
          },
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        dataset: {
          source: [],
        },
        xAxis: {
          type: 'category',
          axisTick: {
            alignWithLabel: true,
          },
          axisLabel: {
            fontSize: 18,
            color: '#828282',
          },
          axisLine: {
            lineStyle: {
              color: '#A3A3A3',
            },
          },
        },
        yAxis: {
          type: 'value',
          max: 100,
          interval: 20,
          axisLabel: {
            fontSize: 18,
            color: '#828282',
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#A3A3A3',
            },
          },
          splitLine: {
            lineStyle: {
              color: '#f5f5f5',
            },
          },
        },
        series: [
          {
            type: 'bar',
            barGap: 0,
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgb(235, 235, 235)' },
                { offset: 1, color: 'rgb(235, 235, 235)' },
              ]),
            },
          },
          {
            type: 'bar',
            barGap: 0,
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: this.currentTheme === 'material-dark' ? 'rgb(185,153,255)' : 'rgb(98, 0, 238)',
                },
                {
                  offset: 1,
                  color: this.currentTheme === 'material-dark' ? 'rgb(185,153,255)' : 'rgb(98, 0, 238)',
                },
              ]),
            },
          },
          {
            type: 'bar',
            barGap: 0,
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgb(96, 175, 32)' },
                { offset: 1, color: 'rgb(96, 175, 32)' },
              ]),
            },
          },
          {
            type: 'bar',
            barGap: 0,
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#F6BE00' },
                { offset: 1, color: '#F6BE00' },
              ]),
            },
          },
        ],
      };
      this.loading = false;
    } catch {
      // console.log('error');
    }
  }

  /**
   * @description
   * Sets the initial viewDate based on the school calendar range.
   * Ensures the chart always loads within the valid academic calendar.
   * @returns void
   */
  private setViewDate(): void {
    try {
      this.loading = true;

      const startDate = new Date(this.currentSchoolCalendar?.start);
      const endDate = new Date(this.currentSchoolCalendar?.end);
      const today = new Date();

      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);

      if (today < startDate) {
        this.viewDate = new Date(startDate);
      } else if (today > endDate) {
        this.viewDate = new Date(endDate);
      } else {
        this.viewDate = new Date(today);
      }

      this.loading = false;
    } catch (error) {
      console.log('setViewDate', error);
      this.loading = false;
    }
  }

  /**
   * @description
   * Determines whether the currently visible calendar month matches the
   * start or end month of the selected school calendar.
   * This helps control calendar navigation (e.g., disabling previous/next
   * navigation when the user reaches the start or end boundary).
   * @returns {void} This function does not return a value. It updates
   * `isCalendarStart` and `isCalendarEnd` flags used for UI navigation control.
   */
  private disableCalendarAsPerDate(): void {
    try {
      // Convert stored calendar start and end values into Date objects
      const startDate = new Date(this.currentSchoolCalendar?.start);
      const endDate = new Date(this.currentSchoolCalendar?.end);
      /**
       * Check if the currently visible calendar month matches
       * the start month of the school calendar.
       * If true → disable "previous" navigation.
       */
      this.isCalendarStart =
        this.viewDate.getMonth() === startDate.getMonth() && this.viewDate.getFullYear() === startDate.getFullYear();

      /**
       * Check if the currently visible calendar month matches
       * the end month of the school calendar.
       * If true → disable "next" navigation.
       */
      this.isCalendarEnd =
        this.viewDate.getMonth() === endDate.getMonth() && this.viewDate.getFullYear() === endDate.getFullYear();
    } catch (error) {
      // Log error to help debug unexpected calendar or date parsing issues
      console.log('disableCalendarAsPerDate', error);
    }
  }

  async getWeeksOfMonth() {
    try {
      this.loading = true;
      const mergeOptions = {
        dataset: {
          source: [['product', 'Mathematics', 'Science', 'English', 'History']],
        },
      };

      const today = new Date(this.viewDate);
      // Validate date
      if (isNaN(today.getTime())) {
        this.loading = false;
        return;
      }

      const currentMonth = today.getMonth();
      today.setDate(1);

      // Move to first Monday of the month
      for (let i = 0; today.getDay() !== 1 && i < 7; i++) {
        today.setDate(today.getDate() + 1);
      }

      // Iterate week by week
      for (let i = 0; today.getMonth() === currentMonth && i < 6; i++) {
        const weekStart = new Date(today);
        const weekEnd = new Date(today);

        weekEnd.setDate(weekEnd.getDate() + 6);

        const data: any = await this.studentAssignments(weekStart.setHours(0, 0, 0, 0), weekEnd.setHours(0, 0, 0, 0));

        const date = getDateAndMonth('week', weekStart);
        mergeOptions.dataset.source.push([date, ...data]);
        today.setDate(today.getDate() + 7);
      }
      this.mergeOptions = mergeOptions;
      this.loading = false;
    } catch (error) {
      this.loading = false;
      // console.log(error);
    }
  }

  async studentAssignments(startDate, endDate) {
    if (!this.isMock) {
      const response = await this.chartService.studentsCompletedAssignmentsAndCharts({
        school_id: this.currentUser?.school_id,
        start_time: startDate,
        end_time: endDate,
      });

      return response?.message !== 'No Records Found' ? response?.data : [0, 0, 0, 0];
    } else {
      return [30, 40, 45, 60];
    }
  }

  /**
   * @description
   * Switches chart period between weekly and monthly views.
   * Loads corresponding data depending on the selected mode.
   * @param event - selected period ('week' | 'month')
   * @returns Promise<void>
   */
  async setPeriodAndGetChartData(event: string): Promise<void> {
    try {
      this.loading = true;
      const value = event;
      if (this.period !== value) {
        this.period = value;

        if (value === 'month' && this.currentUser) {
          this.dividedMonthsValues = await this.divideMonths(
            new Date(this.currentSchoolCalendar?.start),
            new Date(this.currentSchoolCalendar?.end),
          );

          await this.setValuesAndGetMonthsAssignments(true, null);
        } else if (this.currentUser) {
          this.disableCalendarAsPerDate();
          await this.getWeeksOfMonth();
        }
      }

      this.loading = false;
    } catch (error) {
      this.loading = false;
      console.log('setPeriodAndGetChartData', error);
    }
  }

  async setValuesAndGetMonthsAssignments(isNew = false, value: string) {
    try {
      this.loading = true;
      if (value) {
        this.count = value === 'previous' ? this.count - 1 : this.count + 1;
      } else {
        this.count = !isNew ? this.count + 1 : this.count;
      }
      this.disableMonthCalendarNavigation();
      await this.getMonthsData();
      this.loading = false;
    } catch (error) {
      this.loading = false;
      // console.log(error)
    }
  }

  private disableMonthCalendarNavigation(): void {
    try {
      this.isCalendarEnd = this.count === this.dividedMonthsValues.length - 1 ? true : false;

      this.isCalendarStart = this.count === 0 ? true : false;
    } catch (error) {
      // console.log(error)
    }
  }

  async getMonthsData() {
    try {
      const dividedMonthsValue = this.dividedMonthsValues[this.count];
      const allMonths = await this.getMonthsBetweenDates(dividedMonthsValue.startMonth, dividedMonthsValue.endMonth);
      const mergeOptions = {
        dataset: {
          source: [['product', 'Mathematics', 'Science', 'English', 'History']],
        },
      };

      for (const [index, iterator] of allMonths.entries()) {
        const weekStart = new Date(iterator);
        const weekEnd = new Date(
          allMonths[index + 1] ? allMonths[index + 1] : allMonths[index].setMonth(allMonths[index].getMonth() + 1),
        );

        const data: any = await this.studentAssignments(weekStart.setHours(0, 0, 0, 0), weekEnd.setHours(0, 0, 0, 0));

        const date = getDateAndMonth('month', weekStart);

        mergeOptions.dataset.source.push([date, ...data]);
      }

      this.mergeOptions = mergeOptions;
    } catch (error) {
      // console.log(error);
    }
  }

  async getMonthsBetweenDates(startDate, endDate) {
    try {
      const result = [];
      const finalDate = new Date(endDate);
      const start = new Date(startDate);

      // Validate dates
      if (isNaN(start.getTime()) || isNaN(finalDate.getTime()) || start > finalDate) {
        return result;
      }

      for (const currentDate = new Date(start); currentDate <= finalDate && result.length < 36; ) {
        result.push(new Date(currentDate));
        currentDate.setMonth(currentDate.getMonth() + 1);
        currentDate.setDate(1);
      }

      return result;
    } catch (error) {
      console.log('ChartComponent ~ getMonthsBetweenDates ~ error:', error);
      return [];
    }
  }

  async divideMonths(startDate, endDate) {
    try {
      const result = [];
      const start = new Date(startDate);
      const finalDate = new Date(endDate);

      // Validate dates
      if (isNaN(start.getTime()) || isNaN(finalDate.getTime()) || start > finalDate) {
        return result;
      }

      for (
        const currentMonth = new Date(start);
        currentMonth <= finalDate && result.length < 36;
        currentMonth.setMonth(currentMonth.getMonth() + 4)
      ) {
        result.push({
          startMonth: new Date(currentMonth),
          endMonth: new Date(new Date(currentMonth).setMonth(currentMonth.getMonth() + 3)),
        });
      }
      return result;
    } catch (error) {
      console.log('ChartComponent ~ divideMonths ~ error:', error);
      return [];
    }
  }

  /**
   * @description
   * Determines which dataset (weekly or monthly) should be loaded for the chart.
   * Solves the problem of dynamically switching chart data based on the selected period.
   * @returns {Promise<void>} Resolves when the appropriate chart data has been fetched and applied.
   */
  async getData(): Promise<void> {
    try {
      this.loading = true;

      // Update calendar navigation state based on current viewDate
      // This determines whether navigation buttons should be enabled or disabled
      this.disableCalendarAsPerDate();

      // Conditional branch to determine which chart dataset should be loaded
      if (this.period === 'month') {
        // Fetch aggregated monthly assignment data
        // 'true' indicates this is a fresh load rather than navigation
        await this.setValuesAndGetMonthsAssignments(true, null);
      } else {
        // Default behaviour: load weekly assignment data for the selected month
        await this.getWeeksOfMonth();
      }

      this.loading = false;
    } catch (error) {
      this.loading = false;
    }
  }

  /**
   * @description
   * Reloads chart data based on the currently selected period.
   * Ensures chart stays synced after calendar or navigation changes.
   * @returns Promise<void>
   */
  async refreshChartData(): Promise<void> {
    if (this.period === 'month') {
      this.dividedMonthsValues = await this.divideMonths(
        new Date(this.currentSchoolCalendar?.start),
        new Date(this.currentSchoolCalendar?.end),
      );
      await this.setValuesAndGetMonthsAssignments(true, null);
    } else {
      await this.getWeeksOfMonth();
    }
  }
}
